// ============================================
// 残機表示（右パネル下部）
// ============================================

import type p5 from 'p5';
import { getP5 } from '../../core/p5-instance';
import { getLives, getSelectedShip } from '../../store/index';
import { getRightPanelCenterX } from '../../utils/helpers';
import { HUD_COLORS } from '../../config/hud-colors';
import { CONFIG } from '../../config/game-config';
import type { ShipType } from '../../types/game-types';

// レイアウト定数（ボスHP下〜アビリティボタン上の空きスペースに配置）
const LIVES_LABEL_Y = 490;
const LIVES_ICON_Y = 510;
const MAX_LIVES = 3;
const ICON_SPACING = 24;

/**
 * drawCraftIcon() - 機体別の簡易アイコンを描画
 */
function drawCraftIcon(
    p: p5,
    x: number,
    y: number,
    shipType: ShipType,
    color: readonly number[],
    active: boolean
): void {
    const alpha = active ? 255 : 38;
    const ctx = p.drawingContext as CanvasRenderingContext2D;

    p.push();
    p.translate(x, y);
    p.noStroke();

    if (active) {
        ctx.save();
        ctx.shadowColor = `rgba(${color[0]}, ${color[1]}, ${color[2]}, 0.5)`;
        ctx.shadowBlur = 4;
    }

    p.fill(color[0], color[1], color[2], alpha);

    if (shipType === 'bomber') {
        // Bomber: ダイヤモンド/カイト形状
        p.beginShape();
        p.vertex(0, -9);
        p.vertex(-7, 1);
        p.vertex(0, 6);
        p.vertex(7, 1);
        p.endShape(p.CLOSE);
    } else if (shipType === 'hunter') {
        // Hunter: 細身の矢印形状
        p.beginShape();
        p.vertex(0, -10);
        p.vertex(-5, 5);
        p.vertex(0, 2);
        p.vertex(5, 5);
        p.endShape(p.CLOSE);
    } else {
        // Lancer: 双胴型
        p.beginShape();
        p.vertex(-3, -9);
        p.vertex(-6, 5);
        p.vertex(0, 3);
        p.vertex(6, 5);
        p.vertex(3, -9);
        p.vertex(0, -5);
        p.endShape(p.CLOSE);
    }

    if (active) {
        ctx.shadowBlur = 0;
        ctx.restore();
    }

    p.pop();
}

/**
 * drawLivesDisplay() - 残機アイコン一覧を表示
 */
export function drawLivesDisplay(): void {
    const p = getP5();
    const lives = getLives();
    const rightCenterX = getRightPanelCenterX();
    const selectedShip = getSelectedShip();
    const shipColor = CONFIG.ships[selectedShip].color;

    // CRAFT ラベル（Share Tech Mono）
    p.textAlign(p.CENTER, p.TOP);
    p.textFont('Share Tech Mono');
    p.textSize(9);
    p.fill(HUD_COLORS.cyan[0], HUD_COLORS.cyan[1], HUD_COLORS.cyan[2], 179);
    p.noStroke();
    p.text('CRAFT', rightCenterX, LIVES_LABEL_Y);

    // アイコン（横並び）
    const startX = rightCenterX - (MAX_LIVES - 1) * ICON_SPACING / 2;

    for (let i = 0; i < MAX_LIVES; i++) {
        drawCraftIcon(p, startX + i * ICON_SPACING, LIVES_ICON_Y, selectedShip, shipColor, i < lives);
    }

    // フォントを戻す
    p.textFont('Orbitron');
}
